import { t } from 'i18next';

import type { ConversationInventory } from '../services/inventory-service';
import { htmlNodes } from './htmlNodes';

export type InventoryContent = { html: string; text: string };

export const buildInventoryContent = (
  inventory?: ConversationInventory
): InventoryContent => {
  let html = '';
  let text = '';

  if (!inventory || Object.keys(inventory).length === 0) {
    return { html, text };
  }

  const entities = inventory?.entity?.items?.map(i => i.tag) ?? [];
  const timeseries = inventory?.timeseries?.items?.map(i => i.snake) ?? [];
  const webLinks = inventory?.['web-links']?.items?.flatMap(i => i.urls) ?? [];
  const financialStatements =
    inventory?.['financial-statement']?.items?.map(i => i.tag) ?? [];
  const externalData =
    inventory?.['external-data']?.items?.flatMap(i => i.links ?? []) ?? [];

  const sections = [
    {
      title: t('chat:inventory.sections.entities', { count: entities.length }),
      textItems: entities,
      htmlItems: entities,
    },
    {
      title: t('chat:inventory.sections.timeSeries', {
        count: timeseries.length,
      }),
      textItems: timeseries,
      htmlItems: timeseries,
    },
    {
      title: t('chat:inventory.sections.financials', {
        count: financialStatements.length,
      }),
      textItems: financialStatements,
      htmlItems: financialStatements,
    },
    {
      title: t('chat:inventory.sections.externalData', {
        count: externalData.length,
      }),
      textItems: externalData,
      htmlItems: externalData,
    },
    {
      title: t('chat:inventory.sections.webLinks', { count: webLinks.length }),
      textItems: webLinks,
      htmlItems: webLinks,
    },
  ];

  const nonEmpty = sections.filter(s => s.textItems.length > 0);

  if (!nonEmpty.length) {
    return { html, text };
  }

  text += `\n\n## ${t('chat:inventory.sources')}`;
  nonEmpty.forEach(s => {
    text += `\n\n### ${s.title}\n` + s.textItems.map(v => `- ${v}`).join('\n');
  });

  html += htmlNodes.h2(t('chat:inventory.sources'));
  nonEmpty.forEach(s => {
    html += htmlNodes.h3(s.title);
    html += htmlNodes.unorderedList(
      s.htmlItems
        .filter(v => v !== null && v !== undefined)
        .map(v => htmlNodes.unorderedListItem(v))
        .join('')
    );
  });

  return { html, text };
};
